<template>
    <div>
        <div class="cart_item">
            <div class="img_wrap">
                <div>
                    <SHImage class="product_img" :src="item.image_link || ''" />
                </div>
            </div>
            <div>
                <div>
                    <div style="display:flex;">
                        <div style="flex-grow:1;">
                            <h2 v-if="item.display_title" class="product_title font_regular text_black font_600 text_14 word_break">{{ item.display_title }}</h2>
                            <h2 v-else class="product_title font_regular text_black font_600 text_14">
                               {{ item.catalog_title }} - {{ item.varient_title }}
                            </h2>
                            <p class="font_regular font_500 text_14 mt_4 word_break">{{ item.item_price }} {{cart.currency}}</p>
                        </div>
                        <div v-if="isPreview" class="font_regular font_600 text_16" style="text-align: right;">
                            {{ item.orderQuantity }}
                        </div>
                    </div>
                    <!-- <div>
                        <span class="remove_icon" @click="onRemove">
                            <fluent-icon class="text_black_secondary" icon="delete" />
                        </span>
                    </div> -->
                </div>
                <div v-if="!isPreview">
                    <div v-if="!isCatalogLoading" class="quantity_controller">
                        <div @click="onDecrease">
                            <!-- <fluent-icon  class="text_black_secondary control_btn" icon="subtract" /> -->
                            <span class="controll_icon">
                                <fluent-icon icon="subtract" />
                            </span>
                        </div>
                        <div class="font_regular font_500 text_14">{{ item.orderQuantity }}</div>
                        <div @click="onIncrease">
                            <!-- <fluent-icon class="text_black_secondary control_btn" icon="add" /> -->
                            <span class="controll_icon">
                                <fluent-icon icon="add" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="isDivider" class="divider mt_6 mb_6"></div>
    </div>
</template>

<script>
import SHImage from "../../components/SHImage.vue";
import CatelogueItemAPI from "../../../../api/catelogueItemAPI";
import alertMixin from 'shared/mixins/alertMixin';

export default {
    components:{
        SHImage,
    },
    mixins:[alertMixin],
    props:{
        item:{
            type: Object,
            default:{}
        },
        cart:{
            type: Object,
            default:{}
        },
        isDivider:{
            type: Boolean,
            default: false
        },
        isPreview:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            isCatalogLoading: false,
            catelogue: {variants:[]},
            currentDBItem: {},
        }
    },
    computed:{
        currentCart(){
            const currentCart = this.$store.getters["carts/getCurrentCart"](this.$route.params.accountId);
            return currentCart;
        },
    },
    mounted() {
        this.fetchProductById();
    },
    methods:{
        async fetchProductById() {
            const category_id = this.item.catalog_item_id;
            if (!category_id) {
                return
            }
            try {
                this.isCatalogLoading = true;
                const {data} = await CatelogueItemAPI.getCatelogueItemByCategoryId(category_id);
                // filter variant.price > 0
                this.catelogue = data || {variants:[]}

                // add the main catalogue as a variant
                const mainItemPrice = parseFloat(data.price?.split(" ")[0] || 0);
                if (mainItemPrice > 0) {
                    this.catelogue.variants.unshift({
                        id: data.id,
                        title: data.title || "",
                        price: mainItemPrice,
                        available_inventory: data.available_inventory,
                    })
                }

                // this.catelogue.image_link = await this.getValidImageUrl(this.catelogue.image_link);
                // const existingCart = StorageHelpers.getCartById(this.$route.params.accountId);

                const newVariants = this.catelogue.variants.map(variant=>{
                // const existingItem = existingCart.order_items.find(item => item.varient_id === variant.id);
                const existingItem = this.currentCart.order_items.find(item => item.varient_id === variant.id);

                const orderQuantity = existingItem ? existingItem.orderQuantity : 0;

                return {
                    ...variant,
                    price: parseFloat(variant.price),
                    orderQuantity,
                }
                }).filter(variantEl => variantEl.price > 0 && variantEl.available_inventory> 0);
                this.catelogue.variants = newVariants;

                // from the variant, keep only current item in state
                const currentDBItem = this.catelogue.variants.find(el=>el.id === this.item.varient_id);

                if (currentDBItem) {
                    this.currentDBItem = currentDBItem;
                }

            } catch (error) {
                console.error('Error fetching product:', error);
                this.showAlert(this.$t("CATELOGUE_ITEM.API_ERR.CATELOGUE_FETCH"));
            }finally{
                this.isCatalogLoading = false;
            }
        },
        onRemove(){
            this.$emit('onRemove',this.item);
        },
        onIncrease(){
            // check available_inventory with quantity
            if (this.currentDBItem.available_inventory < (this.item.orderQuantity +1)) {
                this.showAlert("Insufficient inventory!");
                return
            }
            // emit to increase quantity
            this.$emit('onQuantityChange',this.item,'increase')
        },
        onDecrease(){
            if (this.item.orderQuantity <=1) {
                // emit to remove this item
                // this.onRemove(); // it will do in onQuantityChange
                // return
            }
            this.$emit('onQuantityChange',this.item,'decrease')
            // emit to decrease the quantity
        },
    },
}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';


.cart_item{
    display: grid;
    grid-template-columns: 60px 1fr;
    gap: 8px;
}
.img_wrap{
    display: flex;
    align-items: flex-start;
}
.product_img{
    width: 60px;
    border-radius: 4px;
}
.product_title{
    text-transform: capitalize;
}
.remove_icon{
    cursor: pointer;
}
.quantity_controller{
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 16px;
    width: fit-content;

    .control_btn{
        border-radius: 4px;
        width: 28px;
        height: 28px;
        padding: 4px;
        background-color: #F2E7FE;
        color: #8D25F6;
        cursor: pointer;
    }
}

.controll_icon{
  max-width: 20px;
  max-height: 20px;
  border: 1px solid;
  display: flex;
  border-radius: 50%;
  background-color:  var(--primary-color);
  cursor: pointer;
  svg{
    color: #fff;
  }
}
</style>